import {Directive, Inject, InjectionToken, Input, OnDestroy, Optional, Provider, Self} from '@angular/core';
import {NgForm} from '@angular/forms';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {catchError, distinctUntilChanged, map, skip, startWith, switchMap, takeUntil} from 'rxjs/operators';

export const FORM_DISABLED_SOURCE = new InjectionToken<Subject<Observable<any>>>('FORM_DISABLED_SOURCE');
export const formDisabledSourceFactory = function(): Subject<Observable<any>> {
    return new Subject<Observable<any>>();
};

export const formDisabledSourceProvider: Provider = {
    provide: FORM_DISABLED_SOURCE,
    useFactory: formDisabledSourceFactory,
};

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]'
})
export class FormDisabledDirective implements OnDestroy {
    protected readonly us$ = new Subject<void>();
    protected readonly source$ = new BehaviorSubject<Observable<Observable<any>>>(undefined);
    protected readonly disabled$ = new BehaviorSubject<boolean>(false);

    constructor(
        @Self()
        protected ngForm: NgForm,
        @Inject(FORM_DISABLED_SOURCE) @Optional()
        $disabledSource: Observable<Observable<any>>
    ) {
        this.disabled$
            .pipe(
                skip(1),
                distinctUntilChanged(),
                takeUntil(this.us$),
            )
            .subscribe($ => {
                if ($) {
                    this.ngForm.form.disable();
                } else {
                    this.ngForm.form.enable();
                }
            });

        this.source$
            .pipe(
                skip(1),
                switchMap(($source: Observable<Observable<any>>) => {
                    if ($source) {
                        return $source
                            .pipe(
                                switchMap(($: Observable<any>) => {
                                    if ($) {
                                        return $
                                            .pipe(
                                                map(() => false),
                                                catchError(() => of(false)),
                                                startWith(true),
                                            );
                                    }
                                    return of(false);
                                }),
                                catchError(() => of(false))
                            );
                    }
                    return of(false);
                }),
                takeUntil(this.us$)
            )
            .subscribe(this.disabled$);

        if ($disabledSource) {
            this.source$.next($disabledSource);
        }
    }

    public ngOnDestroy(): void {
        this.us$.next();
        this.us$.complete();

        this.source$.complete();
        this.disabled$.complete();
        // NgForm should be enabled? o_O
    }

    @Input()
    public set source($value: Observable<Observable<any>>) {
        if (this.source$.value !== $value) {
            this.source$.next($value);
        }
    }
    public get source(): Observable<Observable<any>> { return this.source$.value; }
}
